'use client';

import React from 'react';
import { IconArrowLeft } from '@tabler/icons-react';
import { cn } from '@/lib/utils';
import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from '@/components/ui/card';
import { useLoginForm } from '@/hooks/use-login-form';
import { CredentialsStep } from './auth/credentials-step';
import { OtpStep } from './auth/otp-step';

export function LoginForm({
    className,
    ...props
}: React.ComponentProps<'div'>) {
    const {
        step,
        isLoading,
        error,
        otpCode,
        setOtpCode,
        availableMethods,
        selectedMethod,
        setSelectedMethod,
        isSendingCode,
        countdowns,
        methodStatuses,
        form,
        onSubmitCredentials,
        onSubmitOtp,
        onResendCode,
        goBackToCredentials,
        t,
        tSecurity,
    } = useLoginForm();

    return (
        <div className={cn('flex flex-col gap-6', className)} {...props}>
            <Card className="shadow-xl border-border/50">
                <CardHeader className="space-y-2 p-8 pb-4">
                    <CardTitle>
                        {step === 'otp' ? (
                            <div className="flex items-center gap-2">
                                <button
                                    onClick={goBackToCredentials}
                                    className="p-1 rounded-md hover:bg-muted transition-colors"
                                    type="button"
                                >
                                    <IconArrowLeft className="size-5" />
                                </button>
                                {t('loginTitle')}
                            </div>
                        ) : (
                            t('loginTitle')
                        )}
                    </CardTitle>
                    <CardDescription>
                        <div className="min-h-[48px]">
                            {step === 'otp'
                                ? (selectedMethod === 'totp'
                                    ? tSecurity('enterCode') || "Enter the 6-digit code from your authenticator app."
                                    : selectedMethod === 'telegram'
                                        ? tSecurity('enterTelegramCode')
                                        : tSecurity('enterWhatsappCode'))
                                : t('loginDescription')
                            }
                        </div>
                    </CardDescription>
                </CardHeader>
                <CardContent className="p-8 pt-2">
                    {step === 'credentials' ? (
                        <CredentialsStep
                            form={form}
                            onSubmit={onSubmitCredentials}
                            isLoading={isLoading}
                            error={error}
                        />
                    ) : (
                        <OtpStep
                            otpCode={otpCode}
                            setOtpCode={setOtpCode}
                            availableMethods={availableMethods}
                            selectedMethod={selectedMethod}
                            setSelectedMethod={setSelectedMethod}
                            isLoading={isLoading}
                            error={error}
                            isSendingCode={isSendingCode}
                            countdowns={countdowns}
                            methodStatuses={methodStatuses}
                            onSubmit={onSubmitOtp}
                            onResendCode={onResendCode}
                        />
                    )}
                </CardContent>
            </Card>
        </div>
    );
}
